export default defineNuxtPlugin(() => {
  const { $flags } = useNuxtApp();
  if ($flags?.hasnt('product.rating.review') && $flags?.hasnt('service.rating.review')) {
    return;
  }

  useHead({
    script: [{
      type: 'text/javascript',
      src: 'https://integrations.etrusted.com/applications/widget.js/v2',
      async: true,
      defer: true,
      crossorigin: false,
    }],
  });
});
